export default __webpack_public_path__ + "static/SRI 3260 - Product Specifications & Technical Data-1d55e4a216e0c506c4c0df978139fc03.pdf";